import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToolbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconToolbox"><Path fillRule="evenodd" clipRule="evenodd" d="M20 2H12V10H11.0039V5.14922L8.48453 2H6.52328L4.00391 5.14922V10H2V21H22V10H20V2ZM6.00391 10H9.00391V5.85078L7.52328 4H7.48453L6.00391 5.85078V10ZM18 10V4H14V6H16.0039V8H14V10H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconToolbox;
